const AddressItemContentLoader = () => {
  return (
    <div
      className="rounded-lg py-3 px-4"
      style={{ boxShadow: `0px 0px 8px 0px #A6A6A640` }}
    >
      <div className="relative h-5 w-1/2 bg-light_gray rounded-sm overflow-hidden">
        <div
          className="
            absolute inset-0
            -translate-x-full
            animate-[shimmer_1s_ease-in-out_infinite]
            bg-gradient-to-r
            from-transparent
            via-white
            to-transparent
          "
        />
      </div>
      <div className="space-y-1 mt-3">
        <div className="relative w-1/2 h-2.5 bg-light_gray rounded-sm overflow-hidden">
          <div
            className="
              absolute inset-0
              -translate-x-full
              animate-[shimmer_1s_ease-in-out_infinite]
              bg-gradient-to-r
              from-transparent
              via-white
              to-transparent
            "
          />
        </div>
        <div className="relative w-3/4 h-2.5 bg-light_gray rounded-sm overflow-hidden">
          <div
            className="
              absolute inset-0
              -translate-x-full
              animate-[shimmer_1s_ease-in-out_infinite]
              bg-gradient-to-r
              from-transparent
              via-white
              to-transparent
            "
          />
        </div>
      </div>
    </div>
  );
};

export default AddressItemContentLoader;